import { z } from 'zod';
import { Validation } from '@mews/framework';
import { ExportFormat } from '@mews-commander/data-access';

export enum CityLedgerExportField {
    format = 'format',
    date = 'date',
    owner = 'owner',
    ownerTypes = 'ownerTypes',
    invoiceStatus = 'invoiceStatus',
    balanceMin = 'balanceMin',
    balanceMax = 'balanceMax',
    ageing = 'ageing',
}

export const exportFiltersSchema = z.object({
    [CityLedgerExportField.format]: z.nativeEnum(ExportFormat),
    [CityLedgerExportField.date]: Validation.Date.Iso,
    [CityLedgerExportField.owner]: z.string().nullish(),
    [CityLedgerExportField.ownerTypes]: z.array(z.string()).optional(),
    [CityLedgerExportField.invoiceStatus]: z.array(z.string()).optional(),
    [CityLedgerExportField.balanceMin]: z.number().optional(),
    [CityLedgerExportField.balanceMax]: z.number().optional(),
    [CityLedgerExportField.ageing]: z.array(z.string()).nullable(),
});

export type ExportValues = z.infer<typeof exportFiltersSchema>;
